<template>
  <div class="landing text-center">
    <router-link class="btn m-8" to="starship">
      {{ $t('landing.spaceship-travel') }}
    </router-link>
  </div>
</template>

<script>
export default {
  name: 'LandingView',
  sockets: {
    connect () {
      // this.$socket.emit('login', {
      //   username: 'pablo',
      //   password: 'pablo'
      // })
    }
  }
}
</script>

<style>

</style>

<i18n>
{
  "en": {
    "landing": {
      "spaceship-travel": "Travel to your Spaceship"
    }
  }
}
</i18n>



// WEBPACK FOOTER //
// src/pages/index.vue